import { render } from "./List.vue?vue&type=template&id=19f68aba"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=19f68aba&lang=scss&scope=true"

import exportComponent from "/Users/ondaa/workspace/schoolmom_qna_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__